import { render, staticRenderFns } from "./DataRepository.vue?vue&type=template&id=4a212528&"
import script from "./DataRepository.vue?vue&type=script&lang=ts&"
export * from "./DataRepository.vue?vue&type=script&lang=ts&"
import style0 from "./DataRepository.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports